import http from '@/http'

const PATH = '/numbers/myriad2'

const request = async (method, path, data) => {
    try {
        const response = await http[method](path, data)
        return response.data
    } catch (e) {
        
        return Promise.reject(e)
    }
}

export default {
    show: ({number}) => request('get', `${PATH}/${number}`),
    cancel: ({number}) => request('put', `${PATH}/${number}/cancelNumber`),
    uncancel: ({number}) => request('put', `${PATH}/${number}/uncancelNumber`),
    suspend: ({number}) => request('put', `${PATH}/${number}/suspend`),
    unsuspend: ({number}) => request('put', `${PATH}/${number}/unsuspend`),
    aliasPlan: ({number, target}) => request('put', `${PATH}/${number}/alias/${target}`),
    faxToEmail: ({number, target, params}) => request('put', `${PATH}/${number}/fax-to-email/${target}`, params),
    clone: ({number, target}) => request('put', `${PATH}/${number}/clone/${target}`),
    removePlan: ({number}) => request('delete', `${PATH}/${number}/remove-plan`),
    listBarredNumbers: ({number}) => request('get', `${PATH}/${number}/barring`),
    barNumbers: ({number, clis}) => request('put', `${PATH}/${number}/barring`, {clis}),
    unbarNumbers: ({number, clis}) => request('delete', `${PATH}/${number}/barring`, {data: {clis}})
}
